import { useRef, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";

import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { BarrioContext } from "../components/BarrioContext";
import { useAuth } from "../components/AuthContext";

import { Toast } from 'primereact/toast';
import WebcamCapture from '../components/WebcamCapture';
import LoadingOverlay from '../components/LoadingOverlay';
import { useTerminologia } from '../hooks/useTerminologia';

const Persona = () => {
    const toast = useRef(null);
    const HOST_API = process.env.REACT_APP_URL;
    const { barrio } = useContext(BarrioContext);
    const t = useTerminologia();
    const { administracionId } = useAuth();
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);

    // â”€â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const camelToHeader = (key) =>
        key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();

    const formatValue = (value, type) => {
        if (value === null || value === undefined) return "";
        switch (type) {
            case "date":
                return new Date(value).toLocaleDateString("es-AR");
            case "currency":
                return typeof value === "number"
                    ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
                    : value;
            default:
                return typeof value === "object" ? JSON.stringify(value) : value;
        }
    };

    const flattenRow = (row) => {
        const flat = {};
        for (const [key, value] of Object.entries(row)) {
            if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
                for (const [nestedKey, nestedValue] of Object.entries(value)) {
                    flat[nestedKey] = nestedValue;
                    flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
                }
            } else {
                flat[key] = value;
            }
        }
        return flat;
    };

    // â”€â”€â”€ Estado â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const [tiposPersona,        setTiposPersona]        = useState([]);

    const initialFormData = {
        personaId: 0,
        nombre: "",
        apellido: "",
        razonSocial: "",
        email: "",
        emailAlternativo: "",
        telefono: "",
        telefonoAlternativo: "",
        direccion: "",
        dni: "",
        cuit: "",
        fechaNacimiento: null,
        notas: "",
        tipoPersonaId: "",
        activo: true,
        asamblea: false,
    };

    const [formData, setFormData] = useState(initialFormData);
    const [visible, setVisible] = useState(false);
    const [personas, setPersonas] = useState([]);
    const [fotos, setFotos] = useState({});
    const [asambleaFlags, setAsambleaFlags] = useState({});
    const [guardandoAsamblea, setGuardandoAsamblea] = useState(false);
    const [webcamVisible, setWebcamVisible] = useState(false);
    const [subiendoFoto, setSubiendoFoto] = useState(false);

    const HOST = HOST_API?.replace(/\/+$/, '');

    const fetchFotos = useCallback(async () => {
        if (!barrio?.id) return;
        try {
            const { data } = await axios.get(`${HOST_API}api/personas/GetFotosPersonas?administracionId=${administracionId}&personaId=0&barrioId=${barrio.id}`);
            const mapa = {};
            (data ?? []).forEach((f) => { mapa[f.personaId] = f.fotoUrl; });
            setFotos(mapa);
        } catch { /* silencioso */ }
    }, [barrio?.id, administracionId, HOST_API]);

    useEffect(() => { fetchFotos(); }, [fetchFotos]);

    const fetchAsambleaFlags = useCallback(async () => {
        if (!barrio?.id) return;
        try {
            const { data } = await axios.get(`${HOST_API}api/personas/GetAsambleaPersonas?administracionId=${administracionId}&personaId=0&barrioId=${barrio.id}`);
            const mapa = {};
            (data ?? []).forEach((p) => { mapa[p.personaId] = p.asamblea; });
            setAsambleaFlags(mapa);
        } catch { /* silencioso */ }
    }, [barrio?.id, administracionId, HOST_API]);

    useEffect(() => { fetchAsambleaFlags(); }, [fetchAsambleaFlags]);

    const cambiarAsamblea = async (checked) => {
        if (!formData.personaId) return;
        setGuardandoAsamblea(true);
        try {
            await axios.post(`${HOST_API}api/personas/SaveAsambleaPersona?personaId=${formData.personaId}&asamblea=${checked}`);
            setAsambleaFlags((prev) => ({ ...prev, [formData.personaId]: checked }));
            handleChange('asamblea', checked);
        } catch {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar el flag de asambleas', life: 3000 });
        } finally {
            setGuardandoAsamblea(false);
        }
    };

    const subirFoto = async (blob) => {
        if (!formData.personaId) return;
        setSubiendoFoto(true);
        try {
            const fd = new FormData();
            fd.append('file', blob, 'foto.jpg');
            const { data } = await axios.post(
                `${HOST_API}api/personas/UploadFoto?personaId=${formData.personaId}&administracionId=${administracionId}&barrioId=${barrio.id}`,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            setFotos((prev) => ({ ...prev, [formData.personaId]: data.fotoUrl }));
            setWebcamVisible(false);
            toast.current.show({ severity: 'success', summary: 'Foto guardada', detail: 'La foto se asoció correctamente', life: 2500 });
        } catch {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar la foto', life: 3000 });
        } finally {
            setSubiendoFoto(false);
        }
    };

    const handleChange = (campo, valor) => {
        setFormData((prev) => ({ ...prev, [campo]: valor }));
    };

    // â”€â”€â”€ Submit â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            barrioId:        barrio.id,
            administracionId,
            tipoPersonaId:   parseInt(formData.tipoPersonaId)  || 0,
        };
        try {
            await axios.post(`${HOST_API}api/personas/savePersona`, payload);
            setVisible(false);
            fetchPersonas();
        } catch (err) {
            console.error(err);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: err?.response?.data?.errorDisplay || 'No se pudo guardar la persona',
                life: 4000,
            });
        }
    };

    // â”€â”€â”€ Fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const fetchPersonas = useCallback(async () => {
        if (!barrio?.id) return;
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(
                `${HOST_API}api/personas/GetPersonas?administracionId=${administracionId}&personaId=0&barrioId=${barrio.id}`
            );
            console.log(response.data);
            setPersonas(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener personas");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [barrio?.id, administracionId]);

    useEffect(() => {
        fetchPersonas();
    }, [fetchPersonas]);

    useEffect(() => {
        axios.get(`${HOST_API}api/tipopersona/GetTipoPersonas`)
            .then(({ data }) => setTiposPersona(data))
            .catch(() => {});
    }, [HOST_API]);

    const personasFlat = useMemo(() => personas?.map(flattenRow) ?? [], [personas]);

    const columns = useMemo(() => {
        if (!personasFlat?.length) return [];
        const firstRow = personasFlat[0];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type") && !['barrioId', 'nombreBarrio', 'tipoRelacionId', 'administracionId', 'fechaAlta', 'tipoPersonaId', 'activo', 'nombreCompleto'].includes(key))
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: camelToHeader(field),
            }));
    }, [personas]);

    // â”€â”€â”€ Edit / Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleEdit = async (row) => {
        try {
            const { data } = await axios.get(`${HOST_API}api/personas/GetPersonaById?personaId=${row.personaId}&administracionId=${administracionId}&barrioId=${barrio.id}`);
            setFormData({
                ...initialFormData,
                ...data,
                fechaNacimiento: data.fechaNacimiento ? new Date(data.fechaNacimiento) : null,
                asamblea: asambleaFlags[row.personaId] || false,
            });
        } catch (err) {
            console.error('Error al obtener persona:', err);
            setFormData({
                ...initialFormData,
                ...row,
                fechaNacimiento: row.fechaNacimiento ? new Date(row.fechaNacimiento) : null,
                asamblea: asambleaFlags[row.personaId] || false,
            });
        }
        setVisible(true);
    };

    const handleDelete = (personaId) => {
        confirmDialog({
            message: '¿Estás seguro de eliminar esta persona?',
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/personas/deletePersona/${personaId}`);
                    fetchPersonas();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    // â”€â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    return (
        <>
            <h4>Personas</h4>
            <br />

            <ConfirmDialog />
            <Toast ref={toast} />
            <LoadingOverlay visible={loadingBackdrop} />

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label="Nueva Persona"
                    icon="pi pi-plus"
                    onClick={() => { setFormData(initialFormData); setVisible(true); }}
                />
            </div>

            <Dialog
                header="Persona"
                visible={visible}
                style={{ width: "70vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisible(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmit}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full md:w-3">
                                <label>Nombre</label>
                                <InputText
                                    type="text"
                                    value={formData.nombre || ""}
                                    onChange={(e) => handleChange("nombre", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-3">
                                <label>Apellido</label>
                                <InputText
                                    type="text"
                                    value={formData.apellido || ""}
                                    onChange={(e) => handleChange("apellido", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Razón Social</label>
                                <InputText
                                    type="text"
                                    value={formData.razonSocial || ""}
                                    onChange={(e) => handleChange("razonSocial", e.target.value)}
                                    placeholder="Si la persona es una empresa/entidad"
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Email</label>
                                <InputText
                                    type="email"
                                    value={formData.email || ""}
                                    onChange={(e) => handleChange("email", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Email Alternativo</label>
                                <InputText
                                    type="email"
                                    value={formData.emailAlternativo || ""}
                                    onChange={(e) => handleChange("emailAlternativo", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Teléfono</label>
                                <InputText
                                    type="text"
                                    value={formData.telefono || ""}
                                    onChange={(e) => handleChange("telefono", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Teléfono Alternativo</label>
                                <InputText
                                    type="text"
                                    value={formData.telefonoAlternativo || ""}
                                    onChange={(e) => handleChange("telefonoAlternativo", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>DNI</label>
                                <InputText
                                    type="text"
                                    value={formData.dni || ""}
                                    onChange={(e) => handleChange("dni", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>CUIT</label>
                                <InputText
                                    type="text"
                                    value={formData.cuit || ""}
                                    onChange={(e) => handleChange("cuit", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Fecha de Nacimiento</label>
                                <Calendar
                                    value={formData.fechaNacimiento}
                                    dateFormat="dd/mm/yy"
                                    onChange={(e) => handleChange("fechaNacimiento", e.value)}
                                    showIcon
                                    className="p-inputtext-sm"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Dirección</label>
                                <InputText
                                    type="text"
                                    value={formData.direccion || ""}
                                    onChange={(e) => handleChange("direccion", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Tipo Persona</label>
                                <Dropdown
                                    value={formData.tipoPersonaId || null}
                                    options={tiposPersona}
                                    optionLabel="descripcion"
                                    optionValue="tipoPersonaId"
                                    onChange={(e) => handleChange("tipoPersonaId", e.value)}
                                    placeholder="Seleccioná tipo de persona..."
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full">
                                <label>Notas</label>
                                <InputText
                                    type="text"
                                    value={formData.notas || ""}
                                    onChange={(e) => handleChange("notas", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4 flex align-items-center gap-2 mt-2">
                                <Checkbox
                                    inputId="activo"
                                    checked={formData.activo}
                                    onChange={(e) => handleChange("activo", e.checked)}
                                />
                                <label htmlFor="activo">Activo</label>
                            </div>

                            <div className="w-full md:w-4 flex align-items-center gap-2 mt-2">
                                <Checkbox
                                    inputId="asamblea"
                                    checked={!!formData.asamblea}
                                    disabled={!formData.personaId || guardandoAsamblea}
                                    onChange={(e) => cambiarAsamblea(e.checked)}
                                />
                                <label htmlFor="asamblea">Habilitar para Asambleas</label>
                            </div>

                            <div className="w-full flex align-items-center gap-3 mt-2">
                                {formData.personaId && fotos[formData.personaId]
                                    ? <img src={`${HOST}${fotos[formData.personaId]}`} alt="" style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover' }} />
                                    : <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#f2f4f7', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#98a2b3' }}><i className="pi pi-user" style={{ fontSize: '1.5rem' }} /></div>
                                }
                                {formData.personaId ? (
                                    <Button
                                        label={fotos[formData.personaId] ? 'Reemplazar foto' : 'Agregar foto'}
                                        icon="pi pi-camera"
                                        type="button"
                                        severity="secondary"
                                        outlined
                                        onClick={() => setWebcamVisible(true)}
                                    />
                                ) : (
                                    <span style={{ fontSize: '0.85rem', color: '#98a2b3' }}>Guardá la persona para poder agregarle una foto.</span>
                                )}
                            </div>

                            <div className="col-12 mt-3">
                                <Button label="Guardar" icon="pi pi-save" type="submit" />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <WebcamCapture
                visible={webcamVisible}
                onHide={() => setWebcamVisible(false)}
                onCapture={subirFoto}
                header={subiendoFoto ? 'Guardando...' : 'Foto de la persona'}
            />

            <div className="grid">
                <div className="col-12">
                    <DataTable
                        value={personasFlat}
                        paginator
                        rows={10}
                        showGridlines
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay personas cargadas"
                        className="p-datatable-gridlines bg-white"
                    >
                        <Column
                            header="Foto"
                            style={{ width: '5rem' }}
                            body={(row) => fotos[row.personaId]
                                ? <img src={`${HOST}${fotos[row.personaId]}`} alt="" style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }} />
                                : <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#f2f4f7', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#98a2b3' }}><i className="pi pi-user" /></div>
                            }
                        />
                        {columns.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Estado"
                            style={{ width: '8rem' }}
                            body={(row) => {
                                const s = row.activo
                                    ? { bg: '#ecfdf3', color: '#12b76a', border: '#a9efc5', label: 'Activo' }
                                    : { bg: '#fef3f2', color: '#f04438', border: '#fecdca', label: 'No Activo' };
                                return (
                                    <span style={{
                                        background: s.bg, color: s.color, border: `1px solid ${s.border}`,
                                        fontWeight: 600, fontSize: '0.75rem', padding: '0.15rem 0.6rem', borderRadius: 99,
                                    }}>
                                        {s.label}
                                    </span>
                                );
                            }}
                        />
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEdit(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDelete(row.personaId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default Persona;
